import { config } from '@fortawesome/fontawesome-svg-core';
import '@fortawesome/fontawesome-svg-core/styles';
import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AppProps } from 'next/app';
import Head from 'next/head';
import { UserConfig, appWithTranslation } from 'next-i18next';
import { Toaster, toast } from 'sonner';

import { CHANNEL } from '@boss/constants/corporate-jobs';

import '../styles/global.scss';

import { GoogleTagManagerProvider } from '../containers';
import i18nConfig from '../next-i18next.config';

config.autoAddCss = false;

type Query = {
  meta?: {
    errorMessage?: string;
  };
};

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false } },
  queryCache: new QueryCache({
    onError: (_, query: Query) => {
      if (query?.meta?.errorMessage) {
        toast.error(query.meta.errorMessage);
      }
    },
  }),
});

const favicon = CHANNEL === 'jobs-b2c' ? '/favicon_b2c.ico' : '/favicon_b2b.ico';

const toasterConfig = {
  richColors: true,
  toastOptions: {
    style: { padding: '1rem', fontSize: '1rem' },
  },
  position: 'bottom-right' as const,
  expand: true,
};

const CustomApp = ({ Component, pageProps }: AppProps) => {
  return (
    <>
      <Head>
        <title>{`Welcome to ${CHANNEL}`}</title>
        <link href={favicon} rel="icon" sizes="any" />
      </Head>
      <main className="app">
        <GoogleTagManagerProvider gtmId={process.env.NEXT_PUBLIC_GTM_ID ?? ''} pageProps={pageProps}>
          <QueryClientProvider client={queryClient}>
            <Toaster closeButton {...toasterConfig} />
            <Component {...pageProps} />
          </QueryClientProvider>
        </GoogleTagManagerProvider>
      </main>
    </>
  );
};

export default appWithTranslation(CustomApp, i18nConfig as UserConfig);
